import {
  externalCompanyIdentifier,
  legacyExternalCompanyIdentifier,
} from '@/entities/insurance/config/external-company-identifier';
import { moduleIdentifiers } from '@/entities/insurance/config/module-identifiers';
import { osagoExcludeModules } from '@/entities/insurance/config/osago-exclude-modules';

export default {
  computed: {
    externalCompanyIdentifier() {
      return externalCompanyIdentifier;
    },
    legacyExternalCompanyIdentifier() {
      return legacyExternalCompanyIdentifier;
    },
    osagoExcludeModules() {
      return osagoExcludeModules;
    },
  },
  methods: {
    excludeOsagoModules(externalId) {
      if (!externalId) return false;

      return this.osagoExcludeModules.includes(parseInt(externalId));
    },
    isArx(externalId) {
      if (!externalId) return false;

      return parseInt(externalId) === this.externalCompanyIdentifier.ARX;
    },
    isEwa(moduleId) {
      return parseInt(moduleId) === moduleIdentifiers.Ewa;
    },
    isIngo(externalId) {
      if (!externalId) return false;

      return parseInt(externalId) === this.externalCompanyIdentifier.Ingo || parseInt(externalId) === this.legacyExternalCompanyIdentifier.Ingo;
    },
    isGuardian(externalId) {
      if (!externalId) return false;

      return parseInt(externalId) === this.externalCompanyIdentifier.Guardian;
    },
    isInsuranceCompanyWantsInsurerBirthday(externalId) {
      if (!externalId) return false;

      return [
        this.externalCompanyIdentifier.Knajza,
        this.externalCompanyIdentifier.InterPolis,
        this.externalCompanyIdentifier.Arsenal,
        this.externalCompanyIdentifier.PZU,
      ].includes(parseInt(externalId));
    },
    isInsuranceCompanyWantsOwnerBirthday(externalId) {
      if (!externalId) return false;

      return [
        this.externalCompanyIdentifier.Vuso,
        this.externalCompanyIdentifier.Usg,
      ].includes(parseInt(externalId));
    },
  },
};
